import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import router from './router'
import store from './store'
import '@/assets/font/iconfont.css'
import '@/assets/css/main.css';
import '@/assets/js/filter.js';
import resource from '@/assets/js/resource.js';
import axios from '@/assets/js/serve.js';
import utils from '@/assets/js/utils.js';
import storage from '@/assets/js/storage.js';
import inMark from 'inmark'
import _ from 'lodash'
import moment from 'moment'
import * as echarts from 'echarts'
import common from '@/components/common'
Vue.use(common)
// Vue.use(Viser)
Vue.use(VXETable)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
Vue.prototype.$inMark = inMark;
Vue.prototype.$axios = axios.request;
Vue.prototype.$upload = axios.upload;
Vue.prototype.$uploadChange = axios.uploadChange;
Vue.prototype.$defUpload = axios.defUpload;
Vue.prototype.$invoiceRecognitionUpload = axios.invoiceRecognitionUpload;
Vue.prototype.$laiyOcrBankCardUpload = axios.laiyOcrBankCardUpload;
Vue.prototype.$laiyOcrIdCardUpload = axios.laiyOcrIdCardUpload;
Vue.prototype.$laiyOcrLicenseUpload = axios.laiyOcrLicenseUpload;
Vue.prototype.$laiyOcrPassportUpload = axios.laiyOcrPassportUpload;
Vue.prototype.$getLanguageTypePicRecognitionData = axios.getLanguageTypePicRecognitionData;
Vue.prototype.$wsUrl = axios.wsUrl;
Vue.prototype.$mail = axios.mail;
Vue.prototype.$header = axios.getHeader;
Vue.prototype.$uploadFile = axios.uploadFile;
Vue.prototype.$uploadFile2 = axios.uploadFile2;
Vue.prototype.$moment = moment
Vue.prototype.$resource = resource;
Vue.prototype.$localStorage = storage;
Vue.prototype.$utils = utils;
Vue.prototype.$getSealMark = axios.getSealMark;

// 首页引导插件
import intro from 'intro.js' // introjs库
import 'intro.js/introjs.css' // introjs默认css样式
// introjs还提供了多种主题，可以通过以下方式引入
import 'intro.js/themes/introjs-modern.css' // introjs主题

// 把intro.js加入到vue的prototype中，方便使用，就可以直接通过this.$intro()来调用了
Vue.prototype.$intro = intro

// 全局引入
import 'mv-full-page/lib-dist/mv-full-page.css'
import MvFullPage from 'mv-full-page'

Vue.use(MvFullPage)

console.log('最新版本时间：' + '2020-10-30 10:00')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')